// extracted by mini-css-extract-plugin
module.exports = {"content":"SaleOfferMovileViewColumn_content__KMGjk","date":"SaleOfferMovileViewColumn_date__qTas4","discount":"SaleOfferMovileViewColumn_discount__dPR_z"};